<template>
  <div class="zhHome" onclick="_hmt.push(['_trackEvent', 'website', 'click', '点击'])">
    <meta name="keywords" content="以诺教育，诺亚财富，财商提升，夏令营，海外游学，企业定制，亲子旅游，青少年夏令营，企业管理">
    <meta
      name="description"
      content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    >
    <title>以诺教育-学习创造价值与感动|财商提升|海外游学|企业内训|定制课程|夏令营|青少年成长</title>
    <IndexHead></IndexHead>
    <div class="zhBanner">
      <Carousel autoplay :autoplay-speed="5000" v-model="zhValue">
        <!-- <CarouselItem v-for="items in banner" :key="items.id"> -->
          <CarouselItem>
          <div class="demo-carousel">
            <img src="https://nbp-activity-bucket.noahgroup.com/fed/20260509/image.png" alt class="zhDemoImg" :style="offWidth">
          </div>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="zhRecommend">
      <div class="zhContents">
        <p class="zhRecom">热门推荐</p>
        <p class="zhRecommin">Popular</p>
      </div>
      <div class="zhContentsImg">
        <div class="zh-img-container" v-for="recommend in recommends" :key="recommend.id">
          <div class="zhImg" @click="goCourseDetail(recommend.classes_id)">
            <img :src="recommend.img_url" alt>
            <div class="zhMoster">
              <span class="zhMos">{{recommend.title}}</span>
              <p class="zhWorder" v-html="recommend.introduce"></p>
              <p class="zhMoster-detail">查看详情>></p>
            </div>
          </div>
        </div>
      </div>
      <div class="zhContents">
        <p class="zhRecom">主题课程</p>
        <p class="zhRecommin">Themes</p>
      </div>
      <div class="zhX">
        <router-link
          to="/courseList"
          class="zhThemes"
          @click="_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
        >
          <img src="../../assets/CourseClassifications.png" alt>
          <div class="zhMouse">
            <div class="zhInvestment">财商提升</div>
          </div>
          <img src="../../assets/CourseLists.png" alt class="zhImgList">
        </router-link>
        <router-link
          to="/courseList"
          class="zhThemes"
          @click="_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
        >
          <img src="../../assets/CourseClassifications.png" alt style="top:-400px">
          <div class="zhMouse">
            <div class="zhInvestment">企业管理</div>
          </div>
          <img src="../../assets/CourseLists.png" alt class="zhImgList" style="top:-400px">
        </router-link>
        <router-link
          to="/courseList"
          class="zhThemes"
          @click="_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
        >
          <img src="../../assets/CourseClassifications.png" alt style="top:-780px">
          <div class="zhMouse">
            <div class="zhInvestment">亲子关系</div>
          </div>
          <img src="../../assets/CourseLists.png" alt class="zhImgList" style="top:-780px">
        </router-link>
        <router-link
          to="/courseList"
          class="zhThemes"
          @click="_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
        >
          <img src="../../assets/CourseClassifications.png" alt style="top:-1160px">
          <div class="zhMouse">
            <div class="zhInvestment">心灵成长</div>
          </div>
          <img src="../../assets/CourseLists.png" alt class="zhImgList" style="top:-1160px">
        </router-link>
        <router-link
          to="/courseList"
          class="zhThemes"
          onclick="_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
        >
          <img src="../../assets/CourseClassifications.png" alt style="top:-1540px">
          <div class="zhMouse">
            <div class="zhInvestment">自然人文</div>
          </div>
          <img src="../../assets/CourseLists.png" alt class="zhImgList" style="top:-1540px">
        </router-link>
      </div>
      <!-- <div class="zhContents">
        <p class="zhRecom">授课讲师</p>
        <p class="zhRecommin">Lecturer</p>
      </div> -->
      <!-- <Carousel v-model="zhValue1" class="zhLecturer">
        <CarouselItem>
          <div class="demo-carousel">
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/he.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >2001年，何伯权离开了一手创办的乐百氏。他用十多年时间打造出的这个中国著名饮料品牌，年销售额超过20亿元，被法国达能公司看中并收入囊中。随后，他赴美进修。2003年，何伯权回国，在广州创立今日投资有限公司，它主要致力于早期项目的投资（种子期与天使投资期）。典型投资案例：诺亚控股、7天连锁酒店、久久丫、九钻网、OFFICEBOX办公用品超市、爱康国宾、万乘金融服务集团等。</div>
              </div>
              <p class="zhWor">何伯权</p>
              <p class="zhWors">今日投资创始人、董事长</p>
            </div>
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/tan.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >浙江大学机械工程学士，管理工程硕士，中欧国际工商学院 EMBA，长江商学院 DBA。 曾任北京证券投资银行总经理、湘财贯通资产管理公司总经理，东方富海合伙人，创业 10 年，金融从业 20 余年，成功投资爱康国宾、泰和诚医疗、我武生物等 7 家在海内外上市的医疗健康和消费服务企业。</div>
              </div>
              <p class="zhWor">谭文清</p>
              <p class="zhWors">以诺教育创始人兼董事长、著名投资人</p>
            </div>
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/zhang.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >章嘉玉女士拥有22年基金管理经验。曾任荷兰荷宝投资管理集团亚洲投资中心与大中华区及东南亚行政总裁；荷银投资管理(亚洲)有限公司资深副总、中国区总裁；湘财荷银基金管理公司董事长及泰达荷银基金管理公司副董事长职务。此前在台湾有14年实务工作经验，先后担任怡富证券投资顾问、怡富证券投资信托公司副总经理、光华证券投资信托公司总经理、荷银证券投资信托公司总经理等职务。</div>
              </div>
              <p class="zhWor">章嘉玉</p>
              <p class="zhWors">诺亚财富创始投资人 、财富正行董事长、以诺教育CEO</p>
            </div>
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/xia.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >负责海外宏观经济、投资策略和资产配置和投资策略研究。个人公众号《财经智识》。曾获AT&T亚太地区青年领袖奖、明尼苏达大学最优教学奖、香港大学最受欢迎的财经教授、香港财经分析师亚洲资本市场年度最佳论文等奖项。</div>
              </div>
              <p class="zhWor">夏春</p>
              <p class="zhWors">诺亚国际（香港）有限公司首席研究官</p>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/xia.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >负责海外宏观经济、投资策略和资产配置和投资策略研究。个人公众号《财经智识》。曾获AT&T亚太地区青年领袖奖、明尼苏达大学最优教学奖、香港大学最受欢迎的财经教授、香港财经分析师亚洲资本市场年度最佳论文等奖项。</div>
              </div>
              <p class="zhWor">夏春</p>
              <p class="zhWors">诺亚国际（香港）有限公司首席研究官</p>
            </div>
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/sheng.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >奥纬咨询金融服务咨询部门(简称 fs) 是目前全球最大的专注服务于金融业的专业咨询机构之一, 拥有1000多名专家，是金融服务和风险管理咨询方面的业界领袖。fs的客户涵盖绝大多数全球领先的大型银行和非银行金融机构，其中包括全球前100家金融机构中的80%以上，咨询领域涵盖风险和财务管理、业务战略、兼并收购、组织系统设计等。</div>
              </div>
              <p class="zhWor">盛海诺</p>
              <p class="zhWors">奥纬咨询（Oliver Wyman）合伙人</p>
            </div>
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/lian.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >现在宏利管理的团队负责"亚洲债券"，资产规模逾3000亿，曾荣桓《Asia Asset Management》（亚洲资产管理）杂志最佳亚洲债券管理公司殊荣旗下亚债基金类型完整多元；近8年海外固定收益投资经验，投资范围涵盖公司债、新兴市场债、欧洲金融债、资产证券化产品等；过往管理资产规模约20亿美金投资范围涵盖台湾固定收益资产(公司债、资产证券化商品)、海外固定收益资产(欧洲金融债、新兴市场高收益债、亚洲信用债)。</div>
              </div>
              <p class="zhWor">李安杰</p>
              <p class="zhWors">泰达宏利基⾦公司QDII亚债基金、港股基金经理，CFA</p>
            </div>
            <div class="zhLen">
              <div class="zhImgCon">
                <img src="../../assets/zhong.png" alt class="zhImages">
                <div
                  class="zhLenCon"
                >福盈商学院特约讲师，曾担任安信证券机构客户部量化投资组负责人、安信证券研究中心首席金融工程师，德邦证券金融产品部总监，摩根士丹利证券台北分公司副总裁及交易部主管；目前主要负责证券期货机构业务开发、证券期货和衍生产品Alpha交易策略及量化模型之研发与实际交易之执行、以及量化投资业务开发与创新研究。</div>
              </div>
              <p class="zhWor">钟伯君</p>
              <p class="zhWors">光大证券上海分公司机构业务部负责人</p>
            </div>
          </div>
        </CarouselItem>
      </Carousel> -->
    </div>
    <div class="zhBottom">
      <div class="zhContents">
        <p class="zhRecom zhAddstyle">学员分享</p>
        <p class="zhRecommin">Comment</p>
      </div>
      <div class="zhMokuai">
        <img src="../../assets/Collegeshare.png" alt class="zhCollegeshare">
        <div class="zhFloor">
          <ul class="zhList">
            <li class="zhListItem">
              <p class="zhListP zhadds">财富学堂</p>
            </li>
            <li class="zhListItem">
              <p class="zhListP">以诺动力</p>
            </li>
            <li class="zhListItem">
              <p class="zhListP">斯坦福夏令营</p>
            </li>
            <li class="zhListItem">
              <p class="zhListP">欧洲隐形冠军</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
    <div class="right-buttons">
      <div
        class="right-button"
        :class="buttonIndex == 0? 'active' : ''"
        @click="subscribe();buttonIndex = 0;"
      >
        <span class="iconfont icon-nav_pc-icon_zaixianyuyue"></span>
        <p>在线预约</p>
      </div>
      <div
        class="right-button"
        :class="buttonIndex == 1? 'active' : ''"
        @click="closeSubOnline();openConsult();"
      >
        <span class="iconfont icon-nav_pc-icon_zaixianzixun"></span>
        <p>在线咨询</p>
      </div>
      <div
        class="right-button"
        :class="buttonIndex == 2? 'active' : ''"
        @click="closeSubOnline();buttonIndex = 2;"
        @mouseleave.prevent="buttonIndex == 2? buttonIndex = null: ''"
      >
        <span class="iconfont icon-nav_pc-icon_zixundianhua"></span>
        <p>电话咨询</p>
      </div>
      <div class="right-button" @click="scrollTop()">
        <Icon type="ios-arrow-up"/>
        <p>返回顶部</p>
      </div>
    </div>

    <div class="serverPhone" v-show="buttonIndex == 2">
      <p class="kefuphone">400-820-0025</p>
      <p class="zhuanxian">拨通转6号线进入专线</p>
    </div>
    <div
      class="iframe-container"
      v-if="buttonIndex == 1"
      @click="buttonIndex = null;iframeLoaded = false"
    >
      <Spin fix v-show="!iframeLoaded">
        <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
        <div>加载中</div>
      </Spin>
      <iframe
        id="consult-ol"
        frameborder="0"
        :src="iframeSrc"
        @load="iframeLoad()"
      ></iframe>
    </div>
    <!-- 在线预约 -->
    <div
      class="sub-online-container"
      v-if="!subOnlineClose"
      @click.self="buttonIndex = null;closeSubOnline()"
    >
      <div class="sub-online">
        <div class="title">在线预约免费领取课程资料</div>
        <Form :model="subscribeForm">
          <FormItem v-if="chooseClass">
            <Select v-model="subscribeForm.id" placeholder="请选择课程" size="large">
              <Option
                :value="course.classes_id"
                :label="course.title"
                v-for="course in classList"
                :key="course.id"
              ></Option>
            </Select>
          </FormItem>
          <FormItem v-else>
            <Input :disabled="true" size="large" v-model="subscribeForm.className"></Input>
          </FormItem>
          <FormItem prop="name">
            <Input v-model="subscribeForm.name" placeholder="请输入姓名" :disabled="!!name" size="large"></Input>
          </FormItem>
          <FormItem prop="phone">
            <Input
              v-model="subscribeForm.phone"
              placeholder="手机号"
              :disabled="!!phone"
              size="large"
              :maxlength="11"
              @on-change="FormPhoneChange"
            ></Input>
          </FormItem>
          <FormItem class="tuCode" v-if="needCaptcha">
            <Row type="flex" justify="space-between">
              <Col span="13">
                <Input v-model="subscribeForm.captcha" placeholder="请输入图形验证码" size="large"></Input>
              </Col>
              <Col span="9">
                <img :src="captcha" @click="captchaGet()" alt>
              </Col>
            </Row>
          </FormItem>
          <FormItem class="code" v-if="!token">
            <Row type="flex" justify="space-between">
              <Col span="13">
                <Input v-model="subscribeForm.code" placeholder="请输入验证码" size="large"></Input>
              </Col>
              <Col span="9">
                <Button
                  :class="{'disable': fasong || !subPhone}"
                  :disabled="fasong || !subPhone"
                  @click="codeNumber()"
                >
                  获取验证码
                  <span v-if="fasong">{{time}}</span>
                </Button>
              </Col>
            </Row>
          </FormItem>

          <p class="errormessage sser" v-if="userCode">{{errormess}}</p>
          <FormItem class="submit">
            <Button @click="submit()">立即提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import IndexHead from "../IndexHead/IndexHead";
import Bottom from "../Bottom/Bottom";
export default {
  name: "Home",
  components: { Bottom, IndexHead },
  data() {
    return {
      zhValue: 0,
      zhValue1: 0,
      banner: [],
      offWidth: "",
      buttonIndex: null,
      subOnlineClose: true,
      subscribeForm: {},
      token: localStorage.token,
      name: "",
      phone: "",
      userCode: false,
      errormess: "",
      fasong: false,
      time: 60,
      classList: [],
      // 热门推荐
      recommends: [],
      chooseClass: true,
      iframeLoaded: false,
      subPhone: false,
      captcha: "",
      needCaptcha: false,
      fgroup_num: "",
      user_id: "",
      iframeSrc: ''
    };
  },
  created() {
    let that = this;
    //banner初始化
    that
      .$ajax({
        method: "post",
        url: "/api/get_advert",
        params: { place: 2 }
      })
      .then(function(data) {
        that.banner = data.data.result;
        that.classList = data.data.result.filter(val => {
          if (parseInt(val.classes_id)) return val;
        });
      });
    // 获取用户信息
    if (this.token) {
      this.$ajax({
        method: "post",
        url: "/api/UserInfo"
      }).then(function(data) {
        localStorage.setItem("name", data.data.real_name);
        localStorage.setItem("phone", data.data.phone);
        that.name = that.subscribeForm.name = data.data.real_name;
        that.phone = that.subscribeForm.phone = data.data.phone;
        that.user_id = data.data.user_id;
        that.fgroup_num = data.data.fgroup_num;
      });
    }
    // 热门推荐初始化
    that
      .$ajax({
        method: "post",
        url: "/api/get_advert",
        params: { place: 3 }
      })
      .then(function(data) {
        that.recommends = data.data.result.slice(0, 4);
      });
  },
  mounted() {
    var that = this;
    for (let i = 0; i < $(".demo-carousel").length; i++) {
      $(".demo-carousel")
        .eq(i)
        .children()
        .eq(3)
        .css({ "margin-right": "0" });
    }
    //主题课程
    $(".zhThemes").mouseenter(function() {
      $(this)
        .children(".zhMouse")
        .css({ display: "none" });
      $(this)
        .children(".zhImgList")
        .css({ left: "-20px" });
    });
    $(".zhThemes").mouseleave(function() {
      $(this)
        .children(".zhMouse")
        .css({ display: "block  " });
      $(this)
        .children(".zhImgList")
        .css({ left: "-276px" });
    });
    //授课讲师
    $(".zhImgCon").mouseenter(function() {
      $(this)
        .children(".zhLenCon")
        .css({ top: 0 });
    });
    $(".zhImgCon").mouseleave(function() {
      $(this)
        .children(".zhLenCon")
        .css({ top: "360px" });
    });
    //底部跳转
    $(".zhListItem").click(function() {
      $(".zhListP").css({ color: "#4f4f4f", "border-right": "none" });
      $(this)
        .children(".zhListP")
        .css({ color: "#01b784", "border-right": "2px solid #01b784" });
      if ($(this).index() == 0) {
        $(".zhCollegeshare").css({ top: "-20px" });
      } else if ($(this).index() == 1) {
        $(".zhCollegeshare").css({ top: "-440px" });
      } else if ($(this).index() == 2) {
        $(".zhCollegeshare").css({ top: "-860px" });
      } else if ($(this).index() == 3) {
        $(".zhCollegeshare").css({ top: "-1280px" });
      }
    });
    //banner居中
    // var offsetWidth = (1920 - $(".zhHome").width()) / 2;
    // if (offsetWidth < 0) {
    //   offsetWidth = 0;
    //   that.offWidth = "transform:" + "translateX(-" + offsetWidth + "px" + ")";
    // } else {
    //   that.offWidth = "transform:" + "translateX(-" + offsetWidth + "px" + ")";
    // }

    /*-----------------------------shua--------------------------------------*/

    sessionStorage.setItem("xin", 1);

    //最小屏宽
    var minHeight = $(window).height() + "px";
    $("body").css({ "min-height": minHeight });
  },
  methods: {
    scrollTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    closeSubOnline() {
      this.subOnlineClose = true;
      this.chooseClass = true;
      this.subscribeForm = {};
      this.errormess = "";
      this.userCode = false;
      this.buttonIndex = null;
    },
    codeNumber() {
      this.errormess = "";
      if (this.fasong) return;
      var that = this;
      that.fasong = true;
      that
        .$ajax({
          method: "post",
          url: "/api/auth/sendPhoneCode",
          data: {
            phone: that.subscribeForm.phone,
            need_img_code: 1,
            img_code: that.subscribeForm.captcha
          }
        })
        .then(function(data) {
          if (data.data.error) {
            that.errormess = data.data.error.message;
            that.userCode = true;
            that.fasong = false;
            if (data.data.error.code == 16006) {
              that.needCaptcha = true;
              that.captchaGet();
            }
          } else {
            that.userCode = false;
            that.fasong = true;
            var timera = setInterval(function() {
              that.time--;
              if (that.time == 0) {
                clearInterval(timera);
                that.time = 60;
                that.fasong = false;
              }
            }, 1000);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    submit() {
      this.errormess = "";
      if (!this.subscribeForm.id) {
        this.errormess = "请选择课程";
      }

      if (!this.subscribeForm.name) {
        this.errormess = "请输入正确的姓名";
      }
      // 未登录状态检查姓名与手机号格式
      if (!this.token) {
        if (!/^1[0-9]{10}$/.test(this.subscribeForm.phone)) {
          this.errormess = "请输入正确的手机号";
        }
        if (!this.subscribeForm.code) {
          this.errormess = "请输入验证码";
        }
      }
      if (this.errormess) {
        this.userCode = true;
        return;
      }
      let that = this;
      if (!this.token) {
        that
          .$ajax({
            method: "post",
            url: "/api/reserveAdd",
            data: {
              class_id: that.subscribeForm.id,
              name: that.subscribeForm.name,
              phone: that.subscribeForm.phone,
              source: 4,
              code: that.subscribeForm.code
            }
          })
          .then(function(data) {
            if (data.data.error) {
              that.userCode = true;
              that.errormess = data.data.error.message;
            }
            if (data.data.message == "预约成功") {
              that.closeSubOnline();
              that.$Message.success("预约成功");
            } else {
              that.subOnlineClose = false;
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        that
          .$ajax({
            method: "post",
            url: "/api/reserveAdd",
            data: {
              class_id: that.subscribeForm.id,
              source: 4
            }
          })
          .then(function(data) {
            if (data.data.error) {
              that.userCode = true;
              that.errormess = data.data.error.message;
            }
            if (data.data.message == "预约成功") {
              that.closeSubOnline();
              that.$Message.success("预约成功");
            } else {
              that.subOnlineClose = false;
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    },
    subscribe(course) {
      this.subOnlineClose = false;
      if (course) {
        this.subscribeForm.id = +course.classes_id;
        this.subscribeForm.className = course.title;
        this.subscribeForm.name = this.name;
        this.subscribeForm.phone = this.phone;
        this.chooseClass = false;
      } else {
        this.subscribeForm.name = this.name;
        this.subscribeForm.phone = this.phone;
        this.chooseClass = true;
      }
    },
    // goCourseDetail(id) {
    //   this.$router.push({ name: "CourseDetails", params: { id: id } });
    // },
    iframeLoad() {
      let _this = this;
      setTimeout(function() {
        _this.iframeLoaded = true;
      }, 1000);
    },
    FormPhoneChange(e) {
      this.subPhone = /^1[0-9]{10}$/.test(e.target.value);
      this.needCaptcha = false;
      this.subscribeForm.captcha = null;
    },
    // 获取图形验证码
    captchaGet() {
      var that = this;
      this.$ajax({
        method: "post",
        url: "/api/auth/captchaGet",
        params: { phone: this.subscribeForm.phone }
      })
        .then(function(data) {
          that.captcha = data.data.result.imgData;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    openConsult() {
      let custtype = 1;
      let custkey = "";
      let gpno = "";
      let token = localStorage.token;
      if (token) {
        custtype = 2;
        custkey = this.user_id;
        gpno = this.fgroup_num;
      } else {
        custtype = 1;
        custkey = "";
        gpno = "";
      }
      let url = "https://webchat.noahgroup.com/chat/YNXCXLogin.html";
      let randomStr = Math.random()
        .toString(11)
        .substr(2);
      if (custtype == "1") {
        url = `${url}?custtype=${custtype}&custkey=${randomStr}`;
      } else {
        url = `${url}?custtype=${custtype}&custkey=${custkey}${
          gpno ? `&gpno=${gpno}` : ""
        }`;
      }
      this.buttonIndex = 1;
      this.iframeSrc = url
    }
  }
};
</script>

<style>
.zhHome {
  min-width: 1300px;
  position: relative;
  background: #f4f5f9;
}
.zhHome .demo-carousel a {
  display: block;
}
.zhBanner .demo-carousel {
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  padding-top: 70px;
}
.zhHome .zhDemoImg {
  width: 100%;
  display: block;
  object-position: center;
}
.zhHome .zhRecommend {
  width: 1280px;
  margin: 0 auto;
}
.zhHome .zhContents {
  width: 100%;
  padding: 50px 0 30px;
  box-sizing: border-box;
}
.zhHome .zhRecom {
  font-size: 30px;
  color: #4f4f4f;
  text-align: center;
  padding-bottom: 10px;
}
.zhHome .zhRecommin {
  font-size: 20px;
  color: #cccccc;
  text-align: center;
}
.zhHome .zhContentsImg {
  width: 100%;
  height: 400px;
}
.zhHome .zhX {
  width: 100%;
  height: 360px;
}
.zhHome .zhImg {
  cursor: pointer;
  width: 300px;
  height: 400px;
  background: #c0c0c0;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}
.zhHome .zhImg:hover {
  transform: translateY(-20px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.zhHome .zhImg > img {
  display: block;
  width: 100%;
  height: 100%;
}
.zhHome .zhMoster {
  position: absolute;
  top: 310px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #117557;
  opacity: 0.8;
  box-sizing: border-box;
  padding: 30px 20px;
  transition: all 0.5s ease;
}
.zhImg:hover .zhMoster {
  top: 0;
  text-align: center;
}

.zhImg:hover .zhMos {
  border-bottom: 0;
  padding-top: 32px;
}
.zhImg:hover .zhWorder {
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.zhImg:hover .zhMoster-detail {
  display: block;
}
.zhHome .zhMos {
  display: inline-block;
  font-size: 24px;
  color: #ffffff;
  width: auto;
  padding-bottom: 10px;
  border-bottom: 3px solid #9fcdbc;
  white-space: nowrap;
}
.zhHome .zhWorder {
  font-size: 14px;
  color: #ffffff;
  padding-top: 10px;
  display: none;
  line-height: 30px;
  text-align: left;
  max-height: 250px;
  overflow: hidden;
}
.zhHome .zhThemes {
  overflow: hidden;
  width: 256px;
  height: 360px;
  float: left;
  cursor: pointer;
  position: relative;
}
.zhHome .zhInvestment {
  width: 120px;
  height: 47px;
  text-align: center;
  font-size: 24px;
  color: #ffffff;
  font-weight: bold;
  box-sizing: border-box;
  border-bottom: 2px solid #ffffff;
  position: absolute;
  top: 265px;
  left: 0;
  right: 0;
  margin: auto;
}
.zhHome .zhMouse {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}
.zhHome .zhThemes > img {
  display: block;
  position: absolute;
  top: -20px;
  left: -20px;
}
.zhHome .zhLecturer {
  height: 480px;
  margin-bottom: 54px;
}
.zhHome .zhLen {
  width: 280px;
  height: 480px;
  float: left;
  margin-right: 50px;
  position: relative;
}
.zhHome .zhImgCon {
  width: 100%;
  height: 360px;
  position: relative;
  overflow: hidden;
}
.zhHome .zhImages {
  width: 100%;
  height: 360px;
  display: block;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.zhHome .zhWor {
  padding: 27px 0 15px;
  font-size: 24px;
  color: #4f4f4f;
  text-align: center;
}
.zhHome .zhWors {
  text-align: center;
  font-size: 16px;
  color: #909090;
}
.zhHome .demo-carousel {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.zhHome .zhThemes > .zhImgList {
  position: absolute;
  top: -20px;
  left: -276px;
  display: block;
  transition: all 0.5s ease;
}
.zhHome .zhLenCon {
  line-height: 24px;
  transition: all 0.5s ease;
  width: 100%;
  height: 360px;
  background: #117557;
  opacity: 0.8;
  position: absolute;
  top: 360px;
  left: 0;
  box-sizing: border-box;
  padding: 40px 30px;
  font-size: 14px;
  color: #ffffff;
}
.zhHome .zhBottom {
  width: 100%;
  height: 560px;
  position: relative;
  background: url("../../assets/Collegesharebg.png") no-repeat;
  margin-bottom: 235px;
}
.zhHome .zhAddstyle {
  color: #ffffff;
}
.zhHome .zhMokuai {
  width: 1280px;
  height: 400px;
  background: #ffffff;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.zhHome .zhFloor {
  width: 280px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 450px;
  padding: 60px 25px;
  box-sizing: border-box;
}
.zhHome .zhCollegeshare {
  position: absolute;
  top: -20px;
  left: -20px;
}
.zhHome .zhList {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid #eeeeee;
  padding-right: 40px;
}
.zhHome .zhListItem {
  width: 100%;
  height: 70px;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
}
.zhHome .zhListItem:last-of-type {
  border-bottom: none;
}
.zhHome .zhListP {
  width: 230px;
  height: 100%;
  box-sizing: border-box;
  line-height: 70px;
  font-size: 18px;
  color: #4f4f4f;
}
.zhHome .zhadds {
  color: #01b784;
  border-right: 2px solid #01b784;
}
/*添加*/
.zhHome .ivu-carousel-dots-inside {
  bottom: -14px;
}

.zhMoster .zhMoster-detail {
  color: #f4d66b;
  font-weight: 700;
  text-align: left;
  margin-top: 22px;
  display: none;
}

.zh-img-container {
  float: left;
  margin-right: 20px;
}

.zhImg-appointment {
  margin-top: 17px;
  width: 100%;
  height: 60px;
  border-radius: 8px;
  background-color: #187759;
  text-align: center;
  line-height: 60px;
  font-weight: 700;
  color: #fff;
  font-size: 24px;
  border: 0;
  cursor: pointer;
}
.zhHome .right-buttons {
  width: 60px;
  position: fixed;
  right: 0;
  bottom: 100px;
  color: #fff;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;
  z-index: 20;
}

.zhHome .right-button {
  width: 100%;
  height: 80px;
  background-color: #1f946c;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  font-size: 12px;
  cursor: pointer;
}

.zhHome .right-button.active {
  background-color: #fff;
  color: #1f946c;
}

.zhHome .right-button.active .iconfont {
  color: #1f946c;
}

.zhHome .right-buttons .iconfont {
  font-size: 40px;
  color: #fff;
  overflow: hidden;
  line-height: 40px;
}

.zhHome .right-buttons .ivu-icon {
  font-size: 40px;
  color: #fff;
  overflow: hidden;
  line-height: 40px;
  display: block;
}

/* 弹窗相关 */

.zhHome .sub-online-container {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}

.zhHome .sub-online {
  width: 468px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  overflow: hidden;
}

.zhHome .sub-online .title {
  width: 100%;
  height: 68px;
  left: 68px;
  background-color: #187759;
  color: #fff;
  font-size: 24px;
  text-align: center;
  line-height: 68px;
}

.zhHome .sub-online .ivu-form {
  padding: 24px 31px 19px 24px;
  background-color: #fff;
  width: 100%;
}

.zhHome .sub-online .ivu-input,
.zhHome .sub-online .ivu-select-large.ivu-select-single .ivu-select-selection {
  height: 50px;
  font-size: 16px;
}

.zhHome
  .sub-online
  .ivu-select-large.ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder,
.zhHome
  .sub-online
  .ivu-select-large.ivu-select-single
  .ivu-select-selection
  .ivu-select-selected-value {
  height: 50px;
  line-height: 50px;
}

.zhHome .ivu-select-dropdown {
  position: absolute !important;
  left: 0px !important;
}

.zhHome .sub-online .ivu-form .ivu-form-item {
  margin-bottom: 14px;
}

.zhHome .sub-online .code .ivu-btn {
  background-color: #187759;
  width: 100%;
  border-radius: 4px;
  height: 100%;
  color: #fff;
  font-size: 16px;
}

.zhHome .sub-online .code .ivu-btn.disable {
  background-color: #f3f3f3;
  color: #ccc;
}

.zhHome .sub-online .submit.ivu-form-item {
  margin-bottom: 0;
  margin-top: 27px;
}

.zhHome .submit .ivu-btn {
  width: 100%;
  border-radius: 4px;
  color: #fff;
  background-color: #187759;
  height: 50px;
  font-size: 24px;
  line-height: 50px;
  padding: 0;
}

/* 弹窗相关结束 */
.zhHome .serverPhone {
  width: 166px;
  height: 60px;
  background-color: #187759;
  position: fixed;
  right: 85px;
  bottom: 185px;
  border-radius: 4px;
  /* display: none; */
}

.zhHome .serverPhone::after {
  content: "";
  display: block;
  position: absolute;
  right: -7px;
  top: 10px;
  border-style: solid;
  border-width: 5px 0 5px 7px;
  border-color: transparent transparent transparent #187759;
}
.zhHome .kefuphone {
  font-size: 20px;
  color: #fff;
  text-align: center;
  margin: 10px 0 0 0;
}

.zhHome .zhuanxian {
  font-size: 12px;
  color: #fff;
  margin-left: 22px;
}

.zhHome .iframe-container {
  position: fixed;
  z-index: 19;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.zhHome .iframe-container #consult-ol {
  position: absolute;
  right: 80px;
  bottom: 100px;
  width: 20vw;
  height: 30vw;
  border: 1px solid #dfdfdf;
}
.zhHome .errormessage {
  color: red;
}
.zhHome .demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.zhHome .demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.zhHome .ivu-spin-fix {
  background-color: rgba(0, 0, 0, 0.5);
}
.zhHome .ivu-spin {
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// Home.vue?69358120